<template>
  <div class="background-degradado">
   <div
        class="contactTitleStyles"
        :style="{
          backgroundImage: 'url(' + BASEURL + '/misc/img/site/bg-contact.jpg)',
        }"
      >
        <div class="about-info-title-cobre text-start-title">
          <h1 class="contact-title">Contact</h1>
        </div>
      </div>
  </div>
  <div class="background">
    <div class="contact-page">
      <v-row>
        <v-col cols="12" md="4">
          <div class="contact-emails">
            <div class="email-item">
              <h2>
                <span v-html="filterData('COBRE_CONTACT_01_' + 'EN')"></span>
              </h2>
              <p>
                <span v-html="filterData('COBRE_CONTACT_02_' + 'EN')"></span>
              </p>
              <br />
              <h2>
                <span v-html="filterData('COBRE_CONTACT_03_' + 'EN')"></span>
              </h2>
              <p>
                <span v-html="filterData('COBRE_CONTACT_04_' + 'EN')"></span>
              </p>
              <br />
              <h2>
                <span v-html="filterData('COBRE_CONTACT_05_' + 'EN')"></span>
              </h2>
              <p>
                <span v-html="filterData('COBRE_CONTACT_06_' + 'EN')"></span>
              </p>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="8">
          <!-- Formulario de contacto -->
          <div class="contact-form-container">
            <p class="form-description">
              Thank you for visiting our website. To contact us, please fill the
              short form below.
            </p>

            <form @submit.prevent="submitForm" class="contact-form">
              <!-- Campo Send to -->
              <div class="form-row">
                <div class="form-group full-width">
                  <label for="tomail"
                    >Send to <span class="text-obligatory"> *</span></label
                  >
                  <select
                    v-model="formData.tomail"
                    id="tomail"
                    class="form-control"
                    required
                  >
                    <option value="0">Select recipient</option>
                    <option value="1">Potential Employment</option>
                    <option value="2">Potential Supplier</option>
                    <option value="3">Other Inquiry</option>
                    <option value="inv">Access to Investors</option>
                  </select>
                </div>
              </div>

              <!-- Campos de nombre -->
              <div class="form-row">
                <div class="form-group">
                  <label for="title"
                    >Title
                    <span class="text-obligatory">*</span>
                  </label>
                  <select
                    v-model="formData.title"
                    id="title"
                    class="form-control"
                  >
                    <option>Mr.</option>
                    <option>Mrs.</option>
                    <option>Ms.</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="name"
                    >First Name<span class="text-obligatory"> *</span></label
                  >
                  <input
                    v-model="formData.name"
                    type="text"
                    id="name"
                    class="form-control"
                    placeholder="First Name"
                    required
                  />
                </div>

                <div class="form-group">
                  <label for="lastname"
                    >Last Name<span class="text-obligatory"> *</span></label
                  >
                  <input
                    v-model="formData.lastname"
                    type="text"
                    id="lastname"
                    class="form-control"
                    placeholder="Last Name"
                    required
                  />
                </div>
              </div>

              <!-- Campos de email y compañía -->
              <div class="form-row">
                <div class="form-group half-width">
                  <label for="email"
                    >Email<span class="text-obligatory"> *</span></label
                  >
                  <input
                    v-model="formData.email"
                    type="email"
                    id="email"
                    class="form-control"
                    placeholder="Email"
                    required
                  />
                </div>

                <div class="form-group half-width">
                  <label for="company"
                    >Company<span class="text-obligatory"> *</span></label
                  >
                  <input
                    v-model="formData.company"
                    type="text"
                    id="company"
                    class="form-control"
                    placeholder="Company"
                    required
                  />
                </div>
              </div>

              <!-- Campos de ubicación -->
              <div class="form-row">
                <div class="form-group third-width">
                  <label for="zip">Zip Code</label>
                  <input
                    v-model="formData.zip"
                    type="text"
                    id="zip"
                    class="form-control"
                    placeholder="Zip Code"
                    maxlength="9"
                    @input="formData.zip = formData.zip.replace(/[^0-9]/g, '')"
                  />
                </div>

                <div class="form-group third-width">
                  <label for="city"
                    >City<span class="text-obligatory"> *</span></label
                  >
                  <input
                    v-model="formData.city"
                    type="text"
                    id="city"
                    class="form-control"
                    placeholder="City"
                    required
                  />
                </div>

                <div class="form-group third-width">
                  <label for="country"
                    >Country<span class="text-obligatory"> *</span></label
                  >
                  <input
                    v-model="formData.country"
                    type="text"
                    id="country"
                    class="form-control"
                    placeholder="Country"
                    required
                  />
                </div>
              </div>

              <!-- Campo de asunto -->
              <div class="form-row">
                <div class="form-group full-width">
                  <label for="subject"
                    >Subject<span class="text-obligatory"> *</span></label
                  >
                  <input
                    v-model="formData.subject"
                    type="text"
                    id="subject"
                    class="form-control"
                    placeholder="Subject"
                    required
                  />
                </div>
              </div>

              <!-- Campo de mensaje -->
              <div class="form-row">
                <div class="form-group full-width">
                  <label for="message"
                    >Message<span class="text-obligatory"> *</span></label
                  >
                  <textarea
                    v-model="formData.message"
                    id="message"
                    class="form-control"
                    rows="5"
                    placeholder="Message"
                    required
                  ></textarea>
                </div>
              </div>

              <!-- Botón de envío -->
              <div class="form-row">
                <div class="form-group full-width text-center">
                  <button type="submit" class="btn submit-btn">SEND</button>
                </div>
              </div>
            </form>

            <!-- Mensaje de confirmación -->
            <div v-if="message" class="message-container">
              <p class="message-text">{{ message }}</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { BASEURL } from "@/kernel/utils";
import { sentMessage } from "../services/public-services";
import { showSuccessToast } from "@/kernel/alerts";
import { onMounted, ref } from "vue";
import { getSectionByPageandlanguage } from "../services/sections-service";

export default {
  name: "ContactForm",
  data() {
    return {
      formData: {
        tomail: "0",
        title: "Mr.",
        name: "",
        lastname: "",
        email: "",
        company: "",
        zip: "",
        city: "",
        country: "",
        subject: "",
        message: "",
      },
      message: "",
      filledInputs: false,
      BASEURL,
    };
  },
  methods: {
    validateForm() {
      if (this.formData.tomail < 1) {
        this.message = "Error, You must fill all required fields!";
        this.filledInputs = true;
        return false;
      }

      const requiredFields = [
        "name",
        "lastname",
        "email",
        "company",
        "city",
        "country",
        "subject",
        "message",
      ];

      for (const field of requiredFields) {
        if (!this.formData[field]) {
          this.message = "Error, You must fill all required fields!";
          this.filledInputs = true;
          return false;
        }
      }

      return true;
    },
    async submitForm() {
      this.message = "";
      this.filledInputs = false;

      if (!this.validateForm()) {
        return;
      }

      try {
        const response = await sentMessage(this.formData);
        if (response.status === 200) {
          showSuccessToast(
            "Your message has been sent successfully!",
            "Success"
          );
          this.message = "";
          this.formData = {
            tomail: "0",
            title: "Mr.",
            name: "",
            lastname: "",
            email: "",
            company: "",
            zip: "",
            city: "",
            country: "",
            subject: "",
            message: "",
          };
        } else {
          this.message = "Error, Your message couldn't be sent!";
        }
      } catch (error) {
        console.error("Error:", error);
        this.message = "Something went wrong, your message couldn't be sent";
      }
    },
  },
  setup() {
    const dataContact = ref([
      {
        section_id: "COBRE_CONTACT_01_EN",
        description: "Suppliers Office",
      },
      {
        section_id: "COBRE_CONTACT_01_ES",
        description: "Suppliers Office",
      },
      {
        section_id: "COBRE_CONTACT_02_EN",
        description: "suppliers@cobredelmayo.com",
      },
      {
        section_id: "COBRE_CONTACT_02_ES",
        description: "suppliers@cobredelmayo.com",
      },
      {
        section_id: "COBRE_CONTACT_03_EN",
        description: "Human Resources Office",
      },
      {
        section_id: "COBRE_CONTACT_03_ES",
        description: "Human Resources Office",
      },
      {
        section_id: "COBRE_CONTACT_04_EN",
        description: "hr@cobredelmayo.com",
      },
      {
        section_id: "COBRE_CONTACT_04_ES",
        description: "hr@cobredelmayo.com",
      },
      {
        section_id: "COBRE_CONTACT_05_EN",
        description: "Investor Relations Office",
      },
      {
        section_id: "COBRE_CONTACT_05_ES",
        description: "Investor Relations Office",
      },
      {
        section_id: "COBRE_CONTACT_06_EN",
        description: "ir@cobredelmayo.com",
      },
      {
        section_id: "COBRE_CONTACT_06_ES",
        description: "ir@cobredelmayo.com",
      },
    ]);

    const fetchData = async () => {
      try {
        const dataForm = {
          page: "CONTACT-COBRE",
          language: "EN",
        };
        const response = await getSectionByPageandlanguage(dataForm);
        if (response.status === 200) {
          if (parseInt(response.data.length) !== 0) {
            dataContact.value = response.data;
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const filterData = (found_id) => {
      const filteredData = dataContact.value.filter(
        (item) => item.section_id === found_id
      );
      return filteredData.length > 0 ? filteredData[0].description : null;
    };

    onMounted(() => {
      fetchData();
    });
    return {
      filterData,
    };
  },
};
</script>

<style scoped>
.background-degradado {
  background: linear-gradient(to bottom, black 0px, black 100px, #D32A28 10px, #D32A28 100%);

  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.background {
  background-color: #fffdfd;
}
.contact-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  margin-top: 50px;
  margin-bottom: 50px;
}

.contactTitleStyles {
  background-size: cover;
  background-position: center;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 140%;
  background-position: center;
  background-repeat: no-repeat;
  width: 99%;

}

.text-start-title {
  text-align: start;
  width: 100%;
  padding-left: 10rem;
  padding-top: 10rem;
  padding-right: 1rem;
}

.contact-title {
  margin-top: 54px;
  text-align: start;
  font-size: 4.5rem;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  margin-bottom: 2rem;
  font-weight: bold;
  position: relative;
  display: inline-block;
}
.contact-title::before {
  content: '';
  position: absolute;
  bottom: 0.2rem; /* cerca de la base del texto */
  left: 0;
  width: 100%; /* que cubra todo el texto */
  height: 1rem; /* menos alto para parecer subrayado */
  background-color: rgba(241, 90, 41, 0.6);
  z-index: -1;
}

.contact-emails {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 3rem;
}

.email-item {
  flex: 1;
  min-width: 250px;
  background-color: #da302b;
  color: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.email-item h2 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}

.email-item p {
  font-size: 1rem;
  margin: 0;
}

.contact-form-container {
  background-color: #fff;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.form-description {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: #555;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.form-group {
  flex: 1;
  min-width: 200px;
}

.form-group.half-width {
  flex: 1;
  min-width: calc(50% - 0.5rem);
}

.form-group.third-width {
  flex: 1;
  min-width: calc(33.333% - 0.666rem);
}

.form-group.full-width {
  flex: 100%;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.form-control:focus {
  border-color: #da302b;
  outline: none;
}

.submit-btn {
  background-color: #da302b;
  color: white;
  padding: 1rem 3rem;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  text-transform: uppercase;
  font-weight: bold;
}

.submit-btn:hover {
  background-color: #b82622;
}

.message-container {
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 4px;
}

.message-text {
  text-align: center;
  font-size: 1.1rem;
  color: #da302b;
  font-weight: bold;
}

@media (max-width: 768px) {
  .email-item {
    min-width: 100%;
  }

  .form-group.half-width,
  .form-group.third-width {
    min-width: 100%;
  }

  .contactTitleStyles {
    height: 300px;
  }

  .text-start-title {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.text-obligatory {
  color: #da302b;
}
</style>
